const state = {
    uid: null,
    email: null,
    level: null,
    name: null,
    photoURL: null,
    providerData: null,
};

const mutations = {
    setUser(state, payload) {
        state.uid = payload.uid || null;
        state.email = payload.email || null;
        state.level = payload.level || null;
        state.name = payload.name || null;
        state.photoURL = payload.photoURL || null;
        state.providerData = payload.providerData || null;
    },
    clearUser(state) {
        state.uid = null;
        state.email = null;
        state.level = null;
        state.name = null;
        state.photoURL = null;
        state.providerData = null;
    },
};

export default {
    state,
    mutations,
    actions: {},
    modules: {},
};
